import Select from "../../components/Select/Select";
import Button from "../../components/Button/Button";
import {useEffect, useState} from "react";
import {useHistory} from "react-router";
import Icon from "../../components/icon/Icon";
import iconLogoRaf from "../../img/icons/logoRAF.png"
import ApmsService from "../../services/ApmsService";
import Utils from "../../utils/Utils";

function SelezioneSportello(props) {

    const [state, setState] = useState({})
    const history = useHistory()
    const [suggestionsSportelli,setSuggestionsSportelli] = useState([])
    const sessioneUtente = sessionStorage.getItem("sessioneUtente") ? JSON.parse(sessionStorage.getItem("sessioneUtente")) : {}
    useEffect(() => {
        let sportelli = sessioneUtente.sportelli.split("|")
        let newSportelli = []
        sportelli.forEach(sportello => {
            sportello = sportello.split(";")
            newSportelli.push({
                "descrizione": sportello[0],
                "comuneSportello": sportello[1],
                "nomeSportello": sportello[2],
                "codiceSportello": sportello[3]
            })
        })
        let newState = {...state}
        newState.sportelli = newSportelli
        setState(newState)
    }, [])

    function riceviValoreSportello(state, id, value) {
        let newState = {...state}
        newState[id] = ""
        state.sportelli.forEach(sportello => {
            if (value === sportello.descrizione || value === sportello.codiceSportello) {
                newState[id] = sportello
            }
        })
        return newState
    }

    function onClickButtonProsegui() {
        let newSessione = {...sessioneUtente}
        let params = {
            codiceFiscale : newSessione.codiceFiscale,
            applicazione : "RAF",
            strutture: newSessione.struttura
        }
        let today = new Date();
        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        let dateTime = Utils.todayDate()+'T'+time;
        ApmsService.ricercaUtenti(params).then(res => {
            res.data.elementi.forEach(elemento => {
                elemento.gruppi.forEach(gruppo => {
                    gruppo.attributi.forEach(attributo => {
                        if (attributo.codiceAttributo.toUpperCase() === "RAF-ultimoLogin".toUpperCase()) {
                            attributo.valore = dateTime
                        }
                    })
                })
                let utente = Utils.createJsonUtente(elemento,suggestionsSportelli,JSON.parse(sessionStorage.getItem("comuniPerCodice")))
                ApmsService.modificaUtente(utente).then(res => {
                })
            })
        })
        newSessione.sportello = state.sportello
        newSessione.sportelli = state.sportelli
        sessionStorage.setItem("sessioneUtente", JSON.stringify(newSessione))
        history.push("/registro")
    }

    return (
        <div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                {/* Logo informativo: unico veicolo dell'identita' del servizio in pagina. */}
                <Icon height={"300px"} width={"350px"} path={iconLogoRaf} alt={"Registro Assistenti Familiari"}/>
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <p style={{fontSize: "20px", textAlign: "center"}}>
                    <strong>Salve {sessioneUtente.nome} {sessioneUtente.cognome}</strong>
                    <br/>
                    <span>Selezionare lo sportello su cui si vuole lavorare</span>
                </p>
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Select
                    id={"sportello"}
                    ariaLabel={"Sportello su cui si vuole lavorare"}
                    options={state.sportelli}
                    style={{width:"410px"}}
                    onChange={(event) => setState(riceviValoreSportello(state, event.target.id, event.target.value))}
                    placeholder={"Selezionare uno sportello..."}
                    value={state && state.sportello && state.sportello.descrizione ? state.sportello.descrizione : ""}
                />
            </div>
            <div style={{display: "flex", justifyContent: "center",  alignItems: "center", marginTop: "1rem",marginBottom:"2rem"}}>
                <Button
                    id={"ButtonProsegui"}
                    onClick={onClickButtonProsegui}
                    disabled={!state.sportello}
                    typeButton={"Blue"}
                    text={"Prosegui"}
                    style={{minHeight: "45px",width:"410px"}}
                />
            </div>
        </div>
    )
}

export default SelezioneSportello